import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { IconName } from '@fortawesome/fontawesome-common-types';

@Component({
  selector: 'kh-admin-password-input',
  styleUrls: ['./admin-password-input.component.less'],
  templateUrl: './admin-password-input.component.html',
  standalone: false
})
export class AdminPasswordInputComponent {
  @Input() public password!: AbstractControl;
  @Input() public placeholder!: string;

  public showPassword = false;

  public get currentIcon(): IconName {
    return this.showPassword ? 'eye' : 'eye-slash';
  }

  public toggleShow(): void {
    this.showPassword = !this.showPassword;
  }

  public currentType(): string {
    return this.showPassword ? 'text' : 'password';
  }
}
